module.exports = __webpack_public_path__ + "img/21.0c3bb71e.gif";